var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "div",
        {
          staticClass: "like-c",
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c("div", { staticClass: "wrap", on: { click: _vm.addLike } }, [
            _c("div", { staticClass: "icon" }, [
              _c("div", {
                class: [_vm.isLiked ? "like-icon" : "no-like-icon"],
              }),
              _vm._v(" "),
              _c("div", { ref: "plusOne", staticClass: "like-note" }, [
                _vm._v("+1"),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "count" }, [
              _vm._v(_vm._s(_vm.likeCount)),
            ]),
          ]),
          _vm._v(" "),
          _vm.showDialogLogin
            ? _c("DialogLogin", {
                on: { closeDialogLogin: _vm.handleShowDialogLogin },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }